'use client';

import { tracking } from '@/hotdesk-ui/services/tracking.service';
import { useEffect } from 'react';

/**
 * Fires onScreenChange for the Home screen (Discovery Funnel Step 2).
 * Drop this as a silent component inside the home page server component.
 */
export default function HomeTracking() {
  useEffect(() => {
    tracking.onScreenChange('home', '/home', 'navigation_bar');
  }, []);
  return null;
}